module.exports = __webpack_public_path__ + "img/icon_marketing_on.0c95448c.svg";